module.exports = __webpack_public_path__ + "img/grupo-restaurantero-gigante-github.f75b44c5.webp";